<template>
  <div>
    <div class="mb-5">
      <div class="title black--text">Cuentas</div>

      <v-card v-if="!$vuetify.breakpoint.mobile" outlined>
        <v-simple-table dense>
          <template v-slot:default>
            <thead class="primary">
              <tr>
                <th
                  v-for="(header, i) in cuentasHeader"
                  :key="i"
                  :class="[header.position, headerClasses]"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="listaCuentasEntidad.length === 0" class="text-center">
                <td colspan="7">Sin Movimientos</td>
              </tr>
              <tr
                v-else
                v-for="cuenta in listaCuentasEntidad"
                :key="cuenta.idCuenta"
              >
                <td :class="cuentasHeader[0].position">
                  <v-btn
                    small
                    rounded
                    outlined
                    color="primary"
                    elevation="1"
                    :to="{
                      name: 'cuenta_corriente',
                      params: { cuenta: cuenta.idCuenta },
                    }"
                    class="fh-link text-none"
                  >
                    {{ cuenta.idCuenta | fhCuenta }} ({{
                      cuenta.simboloMoneda
                    }})
                  </v-btn>
                </td>
                <td :class="cuentasHeader[1].position">
                  {{ cuenta.nombreCuenta }}
                </td>
                <td :class="cuentasHeader[2].position">
                  {{ cuenta.abreviacionTipoCuenta }}
                </td>
                <td :class="cuentasHeader[3].position">{{ cuenta.estado }}</td>
                <td :class="cuentasHeader[4].position">
                  {{
                    cuenta.saldoActual
                      | fhDecimalNumber(cuenta.cantidadDecimalesMoneda)
                  }}
                </td>
                <td :class="cuentasHeader[5].position">
                  {{
                    cuenta.saldoDisponible
                      | fhDecimalNumber(cuenta.cantidadDecimalesMoneda)
                  }}
                </td>
                <td :class="cuentasHeader[6].position">
                  <v-btn
                    :to="{
                      name: 'cuenta_corriente',
                      params: { cuenta: cuenta.idCuenta },
                    }"
                    rounded
                    small
                    elevation="0"
                    class="text-none fh-smallbutton grey lighten-2"
                  >
                    Ver más
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <v-row v-else class="fill-width hide-scroll" justify="start">
        <v-col
          v-for="(cuenta, index) in listaCuentasEntidad"
          :key="index + '-cuentas'"
        >
          <v-card
            :to="{
              name: 'cuenta_corriente',
              params: { cuenta: cuenta.idCuenta },
            }"
            class="mx-auto"
            max-width="400"
            min-width="290"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="text-h5"
                  >{{ cuenta.idCuenta | fhCuenta }}
                  <small>
                    ({{ cuenta.simboloMoneda }})</small
                  ></v-list-item-title
                >
                <v-list-item-subtitle>{{
                  cuenta.nombreCuenta
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-action-text>
                  {{ cuenta.abreviacionTipoCuenta }}
                </v-list-item-action-text>
                <v-list-item-action-text>
                  {{ cuenta.estado }}
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle class="pb-0"
                  >Saldo actual
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-h4 black--text">{{
                  cuenta.saldoActual
                    | fhDecimalNumber(cuenta.cantidadDecimalesMoneda)
                }}</v-list-item-subtitle>
                <template v-if="cuenta.saldoActual !== cuenta.saldoDisponible">
                  <v-list-item-subtitle class="pt-3"
                    >Saldo disponible
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text--primary">{{
                    cuenta.saldoDisponible
                      | fhDecimalNumber(cuenta.cantidadDecimalesMoneda)
                  }}</v-list-item-subtitle>
                </template>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-action-text class="d-flex align-center"
                  ><v-icon right color="primary"
                    >mdi-arrow-right</v-icon
                  ></v-list-item-action-text
                >
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-if="listaPrestamosEntidad.length !== 0" class="mb-5">
      <div class="title black--text">Préstamos</div>
      <v-card outlined>
        <v-simple-table dense class="hidden-xs-only">
          <template v-slot:default>
            <thead class="primary">
              <tr>
                <th
                  v-for="(header, i) in prestamosHeader"
                  :key="i"
                  :class="[header.position, headerClasses]"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="prestamo in listaPrestamosEntidad"
                :key="prestamo.idPrestamo"
              >
                <td :class="prestamosHeader[0].position">
                  <router-link
                    :to="{
                      name: 'prestamos',
                      params: { prestamo: prestamo.idPrestamo },
                    }"
                    class="fh-link"
                  >
                    {{ prestamo.proposito.substring(0, 24) }}
                  </router-link>
                </td>
                <td :class="prestamosHeader[1].position">
                  {{ prestamo.fecha | fhDate }}
                </td>
                <td :class="prestamosHeader[2].position">
                  {{ prestamo.siguienteVencimiento | fhDate }}
                </td>
                <td :class="prestamosHeader[3].position">
                  {{ prestamo.cuotas }}
                  <span class="red--text"
                    >({{ prestamo.cuotasPendientes }})</span
                  >
                </td>
                <td :class="prestamosHeader[4].position">
                  {{ prestamo.idCuentaGestion | fhCuenta }}
                </td>
                <td :class="prestamosHeader[5].position">
                  {{ prestamo.capital | fhIntegerNumber }}
                </td>
                <td :class="prestamosHeader[6].position">
                  <v-btn
                    :to="{
                      name: 'prestamos',
                      params: { prestamo: prestamo.idPrestamo },
                    }"
                    rounded
                    small
                    elevation="0"
                    class="text-none fh-smallbutton grey lighten-2"
                  >
                    Ver más
                  </v-btn>
                </td>
              </tr>
              <tr height="80px">
                <td colspan="3"></td>
                <td colspan="2" class="text-right">
                  <v-row no-gutters class="d-flex flex-row-reverse"
                    ><strong>Capital Pendiente:</strong></v-row
                  >
                  <v-row no-gutters class="d-flex flex-row-reverse"
                    ><strong>Interés Pendiente:</strong></v-row
                  >
                  <v-divider></v-divider>
                  <v-row no-gutters class="d-flex flex-row-reverse"
                    ><strong>Total:</strong></v-row
                  >
                </td>
                <td>
                  <v-row no-gutters class="d-flex flex-row-reverse">{{
                    capitalPendiente | fhIntegerNumber
                  }}</v-row>
                  <v-row no-gutters class="d-flex flex-row-reverse">{{
                    interesPendiente | fhIntegerNumber
                  }}</v-row>
                  <v-divider></v-divider>
                  <v-row no-gutters class="d-flex flex-row-reverse">{{
                    totolPendiente | fhIntegerNumber
                  }}</v-row>
                </td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-data-table
          :headers="mobilePrestamoHeader"
          :items="listaPrestamosEntidad"
          :single-expand="singleExpand"
          item-key="idPrestamo"
          :expanded.sync="expandedP"
          :items-per-page="-1"
          dense
          hide-default-footer=""
          show-expand
          @click:row="clickedP"
          class="hidden-sm-and-up"
          :mobile-breakpoint="0"
        >
          <template v-slot:[`item.idPrestamo`]="{ item }">
            <router-link
              :to="{ name: 'prestamos', params: { prestamo: item.idPrestamo } }"
              class="fh-link"
            >
              {{ item.proposito.substring(0, 18) }}
            </router-link>
          </template>
          <template v-slot:[`item.siguienteVencimiento`]="{ item }">
            {{ item.siguienteVencimiento | fhDate }}
          </template>
          <template v-slot:expanded-item="{ item }">
            <td :colspan="mobilePrestamoHeader.length" class="elevation-0">
              <div class="mt-2">
                <span style="font-weight: bold">Cuenta Gestión: </span>
                {{ item.idCuentaGestion | fhCuenta }}
              </div>
              <div>
                <span style="font-weight: bold">Capital: </span>
                {{ item.capital | fhIntegerNumber }}
              </div>
              <div>
                <span style="font-weight: bold">Cuotas: </span>
                {{ item.cuotas }}
                <span class="red--text">({{ item.cuotasPendientes }})</span>
              </div>
              <div>
                <span style="font-weight: bold">Alta: </span>
                {{ item.fecha | fhDate }}
              </div>
              <div class="mb-3">
                <v-btn
                  :to="{
                    name: 'prestamos',
                    params: { prestamo: item.idPrestamo },
                  }"
                  rounded
                  small
                  elevation="0"
                  class="text-none fh-smallbutton grey lighten-2"
                >
                  Ver más
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:[`body.append`]="{}">
            <tr height="80px">
              <td class="text-right pr-0">
                <v-row no-gutters class="d-flex flex-row-reverse"
                  ><strong>Capital Pendiente:</strong></v-row
                >
                <v-row no-gutters class="d-flex flex-row-reverse"
                  ><strong>Interés Pendiente:</strong></v-row
                >
                <v-divider></v-divider>
                <v-row no-gutters class="d-flex flex-row-reverse"
                  ><strong>Total:</strong></v-row
                >
              </td>
              <td colspan="2">
                <v-row no-gutters class="d-flex flex-row-reverse">{{
                  capitalPendiente | fhIntegerNumber
                }}</v-row>
                <v-row no-gutters class="d-flex flex-row-reverse">{{
                  interesPendiente | fhIntegerNumber
                }}</v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="d-flex flex-row-reverse">{{
                  totolPendiente | fhIntegerNumber
                }}</v-row>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div v-if="listaPlazoFijoEntidad.length !== 0" class="mb-5">
      <div class="title black--text">Plazos Fijos</div>
      <v-card outlined>
        <v-simple-table dense class="hidden-xs-only">
          <template v-slot:default>
            <thead class="primary">
              <tr>
                <th
                  v-for="(header, i) in plazoFijoHeader"
                  :key="i"
                  :class="[header.position, headerClasses]"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="plazoFijo in listaPlazoFijoEntidad"
                :key="plazoFijo.idPlazoFijo"
              >
                <td :class="plazoFijoHeader[0].position">
                  <router-link
                    :to="{
                      name: 'plazo_fijo',
                      params: { plazoFijo: plazoFijo.idPlazoFijo },
                    }"
                    class="fh-link"
                  >
                    {{ plazoFijo.idPlazoFijo }}
                  </router-link>
                </td>
                <td :class="plazoFijoHeader[1].position">
                  {{ plazoFijo.fechaVencimiento | fhDate }}
                </td>
                <td :class="plazoFijoHeader[2].position">
                  {{ plazoFijo.tasa | fhDecimalNumber }}
                </td>
                <td :class="plazoFijoHeader[3].position"></td>
                <td :class="plazoFijoHeader[4].position"></td>
                <td :class="plazoFijoHeader[5].position">
                  {{ plazoFijo.capital | fhIntegerNumber }}
                </td>
                <td :class="plazoFijoHeader[6].position">
                  <v-btn
                    :to="{
                      name: 'plazo_fijo',
                      params: { plazoFijo: plazoFijo.idPlazoFijo },
                    }"
                    rounded
                    small
                    elevation="0"
                    class="text-none fh-smallbutton grey lighten-2"
                  >
                    Ver más
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-data-table
          :headers="mobilePlazoFijoHeader"
          :items="listaPlazoFijoEntidad"
          :single-expand="singleExpand"
          item-key="idPlazoFijo"
          :expanded.sync="expandedPF"
          :items-per-page="-1"
          dense
          hide-default-footer=""
          show-expand
          @click:row="clickedPF"
          class="hidden-sm-and-up"
          :mobile-breakpoint="0"
        >
          <template v-slot:[`item.capital`]="{ item }">
            <router-link
              :to="{
                name: 'plazo_fijo',
                params: { plazoFijo: item.idPlazoFijo },
              }"
              class="fh-link"
            >
              {{ item.capital | fhIntegerNumber }}
            </router-link>
          </template>
          <template v-slot:[`item.fechaVencimiento`]="{ item }">
            {{ item.fechaVencimiento | fhDate }}
          </template>
          <template v-slot:expanded-item="{ item }">
            <td :colspan="mobilePlazoFijoHeader.length" class="elevation-0">
              <div class="mt-2">
                <span style="font-weight: bold">Contrato: </span>
                {{ item.idPlazoFijo }}
              </div>
              <div>
                <span style="font-weight: bold">Tasa: </span>
                {{ item.tasa | fhDecimalNumber }}
              </div>
              <div class="mb-3">
                <v-btn
                  :to="{
                    name: 'plazo_fijo',
                    params: { plazoFijo: item.idPlazoFijo },
                  }"
                  rounded
                  small
                  elevation="0"
                  class="text-none fh-smallbutton grey lighten-2"
                >
                  Ver más
                </v-btn>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div v-if="listaFacturaCreditoResumen.length !== 0" class="mb-5">
      <div class="title black--text">Facturas Crédito</div>
      <v-card outlined>
        <v-simple-table dense class="hidden-xs-only">
          <template v-slot:default>
            <thead class="primary">
              <tr>
                <th
                  v-for="(header, i) in facturaCreditoHeader"
                  :key="i"
                  :class="[header.position, headerClasses]"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(facturaCredito, i) in listaFacturaCreditoResumen"
                :key="i"
              >
                <td :class="facturaCreditoHeader[0].position">
                  <router-link
                    :to="{
                      name: 'factura_credito',
                    }"
                    class="fh-link"
                  >
                    {{ facturaCredito.nombreDepartamento }} ({{
                      facturaCredito.moneda
                    }})
                  </router-link>
                </td>
                <td :class="facturaCreditoHeader[1].position"></td>
                <td :class="facturaCreditoHeader[2].position"></td>
                <td :class="facturaCreditoHeader[3].position"></td>
                <td :class="facturaCreditoHeader[4].position"></td>
                <td :class="facturaCreditoHeader[5].position">
                  {{
                    facturaCredito.saldo
                      | fhDecimalNumber(facturaCredito.decimalesMoneda)
                  }}
                </td>
                <td :class="facturaCreditoHeader[6].position"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-data-table
          :headers="mobileFacturaCreditoHeader"
          :items="listaFacturaCreditoResumen"
          :items-per-page="-1"
          dense
          hide-default-footer=""
          class="hidden-sm-and-up"
          :mobile-breakpoint="0"
        >
          <template v-slot:[`item.nombreDepartamento`]="{ item }">
            <router-link
              :to="{
                name: 'factura_credito',
              }"
              class="fh-link"
            >
              {{ item.nombreDepartamento }} ({{ item.moneda }})
            </router-link>
          </template>
          <template v-slot:[`item.saldo`]="{ item }">
            {{ item.saldo | fhDecimalNumber(item.decimalesMoneda) }}
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div v-if="datosEntidad !== null" class="mb-5">
      <div class="title black--text">Otros Haberes</div>
      <v-card outlined>
        <v-simple-table dense class="hidden-xs-only">
          <template v-slot:default>
            <thead class="primary">
              <tr>
                <th
                  v-for="(header, i) in datosSocioHeader"
                  :key="i"
                  :class="[header.position, headerClasses]"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="datosEntidad.ahorroIndividualLargoPlazo !== 0">
                <td :class="datosSocioHeader[0].position">
                  Ahorro individual a largo plazo
                </td>
                <td :class="datosSocioHeader[1].position"></td>
                <td :class="datosSocioHeader[2].position"></td>
                <td :class="datosSocioHeader[3].position"></td>
                <td :class="datosSocioHeader[4].position"></td>
                <td :class="datosSocioHeader[5].position">
                  {{
                    datosEntidad.ahorroIndividualLargoPlazo | fhIntegerNumber
                  }}
                </td>
                <td :class="datosSocioHeader[6].position"></td>
              </tr>
              <tr v-if="datosEntidad.certificadosAportacion !== 0">
                <td :class="datosSocioHeader[0].position">
                  Certificados de Aportación
                </td>
                <td :class="datosSocioHeader[1].position"></td>
                <td :class="datosSocioHeader[2].position"></td>
                <td :class="datosSocioHeader[3].position"></td>
                <td :class="datosSocioHeader[4].position"></td>
                <td :class="datosSocioHeader[5].position">
                  {{ datosEntidad.certificadosAportacion | fhIntegerNumber }}
                </td>
                <td :class="datosSocioHeader[6].position"></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-simple-table dense class="hidden-sm-and-up">
          <template v-slot:default>
            <thead class="primary">
              <tr>
                <th
                  v-for="(header, i) in mobileDatosSocioHeader"
                  :key="i"
                  :class="[header.position, headerClasses]"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="datosEntidad.ahorroIndividualLargoPlazo !== 0">
                <td :class="mobileDatosSocioHeader[0].position">
                  Ahorro individual a largo plazo
                </td>
                <td :class="mobileDatosSocioHeader[1].position">
                  {{
                    datosEntidad.ahorroIndividualLargoPlazo | fhIntegerNumber
                  }}
                </td>
              </tr>
              <tr v-if="datosEntidad.certificadosAportacion !== 0">
                <td :class="mobileDatosSocioHeader[0].position">
                  Certificados de Aportación
                </td>
                <td :class="mobileDatosSocioHeader[1].position">
                  {{ datosEntidad.certificadosAportacion | fhIntegerNumber }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </div>
    <div class="mb-5">
      <v-alert type="info" elevation="2">
        <v-row align="center">
          <v-col class="grow">
            Para ver los precios valor producto de carne y leche y otras
            informaciones proveídas por el Departamento de Finanzas, accede a la
            página de Area de Socios. (Sólo para socios de la Cooperativa y
            Asociación Fernheim)
          </v-col>
          <v-col class="shrink">
            <v-btn
              ><a
                :href="'https://areasocios.fernheim.com.py/finanzabteilung/'"
                :target="'_blank'"
                rel="noopener noreferrer"
                class="text-decoration-none white--text"
                ><div>Area de Socios</div></a
              ></v-btn
            >
          </v-col>
        </v-row>
      </v-alert>
    </div>
    <div>
      <v-row justify="center">
        <v-col md="8">
          <div class="title text-center secondary--text">
            Cotización de Monedas Extranjeras en Efectivo
          </div>
          <v-row>
            <v-col cols="12" sm="6">
              <v-card outlined>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead class="secondary">
                      <tr>
                        <th
                          v-for="(header, i) in monedaCompraVentaHeader"
                          :key="i"
                          :class="[header.position, headerClasses]"
                        >
                          {{ header.title }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Dólar USA</td>
                        <td :class="monedaCompraVentaHeader[1].position">
                          {{ cotizacionMoneda.usdCompra | fhIntegerNumber }}
                        </td>
                        <td :class="monedaCompraVentaHeader[2].position">
                          {{ cotizacionMoneda.usdVenta | fhIntegerNumber }}
                        </td>
                      </tr>
                      <tr>
                        <td>Dólar Canadiense</td>
                        <td :class="monedaCompraVentaHeader[1].position">
                          {{ cotizacionMoneda.canCompra | fhIntegerNumber }}
                        </td>
                        <td :class="monedaCompraVentaHeader[2].position">
                          {{ cotizacionMoneda.canVenta | fhIntegerNumber }}
                        </td>
                      </tr>
                      <tr>
                        <td>Euro</td>
                        <td :class="monedaCompraVentaHeader[1].position">
                          {{ cotizacionMoneda.euroCompra | fhIntegerNumber }}
                        </td>
                        <td :class="monedaCompraVentaHeader[2].position">
                          {{ cotizacionMoneda.euroVenta | fhIntegerNumber }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card outlined>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead class="secondary">
                      <tr>
                        <th
                          v-for="(header, i) in monedaCompraVentaHeader"
                          :key="i"
                          :class="[header.position, headerClasses]"
                        >
                          {{ header.title }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Real</td>
                        <td :class="monedaCompraVentaHeader[1].position">
                          {{ cotizacionMoneda.realCompra | fhIntegerNumber }}
                        </td>
                        <td :class="monedaCompraVentaHeader[2].position">
                          {{ cotizacionMoneda.realVenta | fhIntegerNumber }}
                        </td>
                      </tr>
                      <tr>
                        <td>Peso Argentino</td>
                        <td :class="monedaCompraVentaHeader[1].position">
                          {{ cotizacionMoneda.argCompra | fhIntegerNumber }}
                        </td>
                        <td :class="monedaCompraVentaHeader[2].position">
                          {{ cotizacionMoneda.argVenta | fhIntegerNumber }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </v-col>
          </v-row>
          <div class="text-center mt-3 caption black--text">
            Cotizaciones vigentes en Filadelfia el
            <span class="font-weight-medium">{{
              cotizacionMoneda.fecha | fhDate
            }}</span>
            a las
            <span class="font-weight-medium">{{ cotizacionMoneda.hora }}</span>
            hs.
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "EstadoCuentas",

  data: () => ({
    expanded: [],
    expandedP: [],
    expandedPF: [],
    singleExpand: true,
    headerClasses: "white--text body-2 font-weight-medium text-no-wrap",
    cuentasHeader: [
      { title: "Número", position: "t-col-1 text-left" },
      { title: "Nombre", position: "t-col-2 text-left" },
      { title: "Tipo", position: "t-col-3 text-left" },
      { title: "Estado", position: "t-col-4 text-left" },
      { title: "Saldo", position: "t-col-5 text-right" },
      { title: "Saldo Disponible", position: "t-col-6 text-right" },
      { title: "", position: "t-col-7 text-center" },
    ],
    mobileCuentasHeader: [
      {
        text: "Número",
        align: "left ",
        sortable: false,
        value: "idCuenta",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
      {
        text: "Saldo",
        align: "right",
        sortable: false,
        value: "saldoActual",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
      {
        text: " ",
        align: "right",
        value: "data-table-expand",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
    ],
    mobilePlazoFijoHeader: [
      {
        text: "Capital",
        align: "left ",
        sortable: false,
        value: "capital",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
      {
        text: "Venc.",
        align: "right",
        sortable: false,
        value: "fechaVencimiento",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
      {
        text: " ",
        align: "right",
        value: "data-table-expand",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
    ],
    prestamosHeader: [
      { title: "Descripción", position: "t-col-1 text-left" },
      { title: "Alta", position: "t-col-2 text-left" },
      { title: "Prox. Venc.", position: "t-col-3 text-left" },
      { title: "Cuotas", position: "t-col-4 text-left" },
      { title: "Cuenta Gestión", position: "t-col-5 text-right" },
      { title: "Capital", position: "t-col-6 text-right" },
      { title: "", position: "t-col-7 text-center" },
    ],
    mobilePrestamoHeader: [
      {
        text: "Desc.",
        align: "left ",
        sortable: false,
        value: "idPrestamo",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
      {
        text: "Venc.",
        align: "right",
        sortable: false,
        value: "siguienteVencimiento",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
      {
        text: " ",
        align: "left",
        value: "data-table-expand",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
    ],
    plazoFijoHeader: [
      { title: "Contrato", position: "t-col-1 text-left" },
      { title: "Vencimiento", position: "t-col-2 text-left" },
      { title: "Tasa", position: "t-col-3 text-left" },
      { title: "", position: "t-col-4 text-left" },
      { title: "", position: "t-col-5 text-right" },
      { title: "Capital", position: "t-col-6 text-right" },
      { title: "", position: "t-col-7 text-center" },
    ],
    facturaCreditoHeader: [
      { title: "Departamento", position: "t-col-1 text-left" },
      { title: "", position: "t-col-2 text-left" },
      { title: "", position: "t-col-3 text-left" },
      { title: "", position: "t-col-4 text-left" },
      { title: "", position: "t-col-5 text-right" },
      { title: "Saldo", position: "t-col-6 text-right" },
      { title: "", position: "t-col-7 text-center" },
    ],
    mobileFacturaCreditoHeader: [
      {
        text: "Departamento",
        align: "left ",
        sortable: false,
        value: "nombreDepartamento",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
      {
        text: "Saldo",
        align: "right",
        sortable: false,
        value: "saldo",
        class: "primary white--text body-2 font-weight-medium text-no-wrap",
      },
    ],
    monedaCompraVentaHeader: [
      { title: "Moneda", position: "text-left" },
      { title: "Compra", position: "text-right" },
      { title: "Venta", position: "text-right" },
    ],
    datosSocioHeader: [
      { title: "Tipo", position: "t-col-1 text-left" },
      { title: "", position: "t-col-2 text-left" },
      { title: "", position: "t-col-3 text-left" },
      { title: "", position: "t-col-4 text-left" },
      { title: "", position: "t-col-5 text-right" },
      { title: "Saldo", position: "t-col-6 text-right" },
      { title: "", position: "t-col-7 text-center" },
    ],
    mobileDatosSocioHeader: [
      { title: "Tipo", position: "text-left" },
      { title: "Saldo", position: "text-right" },
    ],
  }),
  computed: {
    ...mapState("valores", [
      "listaCuentasEntidad",
      "listaPlazoFijoEntidad",
      "listaPrestamosEntidad",
      "listaFacturaCreditoResumen",
      "cotizacionMoneda",
      "datosEntidad",
    ]),
    ...mapState("prestamo", ["listaPrestamos"]),
    capitalPendiente() {
      return this.listaPrestamos.reduce(
        (suma, prestamo) => suma + prestamo.capitalTotal,
        0
      );
    },
    interesPendiente() {
      return this.listaPrestamos.reduce(
        (suma, prestamo) => suma + prestamo.interesesTotal,
        0
      );
    },
    totolPendiente() {
      return this.listaPrestamos.reduce(
        (suma, prestamo) => suma + prestamo.total,
        0
      );
    },
  },
  methods: {
    ...mapActions("valores", ["fetchGeneral"]),
    ...mapActions("prestamo", ["fetchPrestamos"]),
    clickedC(value) {
      this.expanded = value === this.expanded[0] ? [] : [value];
    },
    clickedP(value) {
      this.expandedP = value === this.expandedP[0] ? [] : [value];
    },
    clickedPF(value) {
      this.expandedPF = value === this.expandedPF[0] ? [] : [value];
    },
  },
  async mounted() {
    await this.fetchGeneral();
    await this.fetchPrestamos();
  },
};
</script>

<style scoped>
.t-col-1 {
  width: 20%;
}

.t-col-2 {
  width: 13%;
}

.t-col-3 {
  width: 13%;
}

.t-col-4 {
  width: 10%;
}

.t-col-5 {
  width: 15%;
}

.t-col-6 {
  width: 15%;
}

.t-col-7 {
  width: 10%;
}

.fh-link {
  text-decoration: none;
}

.v-btn.fh-smallbutton {
  font-size: 12px;
  height: 20px;
  padding: 0 8px;
}

.fill-width {
  overflow-x: auto;
  flex-wrap: nowrap;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scroll {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
